import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import {
    Allergy,
    AllergyProfile,
    KnownStatus,
} from "src/components/shared/patients/health_profile/healthProfileSchema";
import { BASE_API_URL, BASE_SECURE_ROUTE } from "src/constants";
import { handleBackendHttpError } from "../handleBackendHttpError";

interface AllergyState {
    allergyProfile: AllergyProfile;
    drawerAllergy: Allergy | undefined;
    currentAccountPatientId: number;
    loadingData: boolean;
    savingData: boolean;
}

const initialAllergyProfileState: AllergyProfile = {
    allergies: [],
    allergyKnownStatus: KnownStatus.UNKNOWN,
    patientFullName: "",
};

export const intialAllergyState: AllergyState = {
    allergyProfile: initialAllergyProfileState,
    drawerAllergy: undefined,
    loadingData: false,
    savingData: false,
    currentAccountPatientId: -1,
};

const allergySlice = createSlice({
    name: "allergy",
    initialState: intialAllergyState,
    reducers: {
        setAllergies: (state, action: PayloadAction<Allergy[]>) => {
            state.allergyProfile = {
                ...state.allergyProfile,
                allergies: action.payload,
            };
        },
        setDrawerAllergy: (state, action: PayloadAction<Allergy | undefined>) => {
            state.drawerAllergy = action.payload;
        },
        setAllergyKnownStatus: (state, action: PayloadAction<KnownStatus>) => {
            state.allergyProfile = { ...state.allergyProfile, allergyKnownStatus: action.payload };
        },
        resetAllergyState: (state) => {
            state.allergyProfile = initialAllergyProfileState;
            state.drawerAllergy = undefined;
            state.loadingData = false;
            state.savingData = false;
            state.currentAccountPatientId = -1;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllergiesAsync.pending, (state) => {
            state.loadingData = true;
        });
        builder.addCase(fetchAllergiesAsync.fulfilled, (state, action) => {
            // Do i need to use state?
            return {
                ...state,
                ...action.payload,
            };
        });
        builder.addCase(fetchAllergiesAsync.rejected, (state) => {
            state.loadingData = false;
        });
    },
});

export const fetchAllergiesAsync = createAsyncThunk(
    "allergy/fetchAllergies",
    async (accountPatientId: number | undefined) => {
        if (accountPatientId === undefined || accountPatientId < 0) {
            return intialAllergyState;
        }

        const url = `${BASE_API_URL}/${BASE_SECURE_ROUTE}/staff/account_patients/health-profile/allergies?accountPatientId=${accountPatientId}`;
        return await axios
            .get<AllergyProfile>(url, { withCredentials: true })
            .then((response) => {
                return {
                    ...intialAllergyState,
                    allergyProfile: response.data,
                    currentAccountPatientId: accountPatientId,
                };
            })
            .catch((e) => {
                handleBackendHttpError(e);
                return {
                    ...intialAllergyState,
                    currentAccountPatientId: accountPatientId,
                };
            });
    },
);

export const { setAllergies, setAllergyKnownStatus, setDrawerAllergy, resetAllergyState } =
    allergySlice.actions;

export default allergySlice.reducer;
